import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import type { Employee } from '../employee/employee';
import { EboTenantItem } from './ebo-tenant-item';

export class EboTenantItemTo extends EboTenantItem {
  modifiedOn: Dayjs;
  modifiedById: string;
  modifiedBy: Employee;
  modifiedViaId: string;

  constructor(jsonData: Partial<EboTenantItemTo>) {
    super(jsonData);
    if (jsonData) {
      // ** Create complex objects
      if (jsonData.modifiedBy) {
        // Lazy import to avoid circular dependency
        const { Employee } = require('../employee/employee');
        this.modifiedBy = new Employee(jsonData.modifiedBy);
      }
      if (jsonData.modifiedOn) this.modifiedOn = SDate.newUtc(jsonData.modifiedOn);
    }
  }
}
